module.exports = __webpack_public_path__ + "img/1.b371f5fc.png";